"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VIEWPORT_HEIGHT = exports.PIXEL = exports.WIDGET_POSITION_MARGIN = exports.VC_HEADER_HEIGHT = exports.MIN_BADGE_REDUCED_WIDTH_ADJUSTED = exports.MIN_BADGE_HEIGHT_ADJUSTED = exports.WidgetTriggerStatus = exports.LoadStatus = exports.widgetStatesProps = exports.SHOW_DELPHI_WIDGET = exports.REMOVE_DELPHI_WIDGET = exports.WidgetStates = void 0;
var WidgetStates;
(function (WidgetStates) {
    WidgetStates["MIN"] = "MIN";
    WidgetStates["MAX"] = "MAX";
    WidgetStates["MIN_BADGE"] = "MIN_BADGE";
    WidgetStates["MIN_WITH_POPOVER"] = "MIN_WITH_POPOVER";
})(WidgetStates = exports.WidgetStates || (exports.WidgetStates = {}));
/**
 * REMOVE_DELPHI_WIDGET is a widget state triggered when the vendor clicks on the widget close button
 */
exports.REMOVE_DELPHI_WIDGET = 'REMOVE_DELPHI_WIDGET';
/**
 * SHOW_DELPHI_WIDGET is a widget state triggered when the widget actually needs to be shown to end user.
 */
exports.SHOW_DELPHI_WIDGET = 'SHOW_DELPHI_WIDGET';
exports.widgetStatesProps = {
    [WidgetStates.MIN]: {
        width: '85',
        height: '65'
    },
    [WidgetStates.MAX]: {
        width: '410',
        height: '100'
    },
    [WidgetStates.MIN_BADGE]: {
        width: '280',
        height: '120'
    },
    [WidgetStates.MIN_WITH_POPOVER]: {
        width: '280',
        height: '100'
    }
};
var LoadStatus;
(function (LoadStatus) {
    LoadStatus["SUCCESS"] = "success";
    LoadStatus["FAIL"] = "fail";
})(LoadStatus = exports.LoadStatus || (exports.LoadStatus = {}));
var WidgetTriggerStatus;
(function (WidgetTriggerStatus) {
    WidgetTriggerStatus["SUCCESS"] = "success";
    WidgetTriggerStatus["FAIL"] = "fail";
})(WidgetTriggerStatus = exports.WidgetTriggerStatus || (exports.WidgetTriggerStatus = {}));
exports.MIN_BADGE_HEIGHT_ADJUSTED = 25;
exports.MIN_BADGE_REDUCED_WIDTH_ADJUSTED = 15;
exports.VC_HEADER_HEIGHT = 48;
exports.WIDGET_POSITION_MARGIN = '1%';
exports.PIXEL = 'px';
exports.VIEWPORT_HEIGHT = 'vh';
